import { Component, Input, SimpleChange, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
	selector: 'ztsi-switch',
	templateUrl: './ztsi-switch.component.html',
	styleUrls: ['./ztsi-switch.component.css'],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => ZtsiSwitchComponent),
			multi: true
		}
	]
})
export class ZtsiSwitchComponent implements ControlValueAccessor {
	//https://coryrylan.com/blog/angular-custom-form-controls-with-reactive-forms-and-ngmodel
	//https://stackoverflow.com/questions/45659742/angular4-no-value-accessor-for-form-control

	@Input() label: string = '';
	@Input('value') _value: boolean;
	@Input() isDisabled: boolean = false;

	onChange: any = () => { };
	onTouched: any = () => { };

	get value() {
		return this._value;
	}

	set value(val) {
		this._value = val;
		this.onChange(val);
		this.onTouched();
	}

	writeValue(value): void {
		if (value !== undefined) {
			this._value = value;
		}
	}

	registerOnChange(fn: any): void {
		this.onChange = fn;
	}

	registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}
}



// WEBPACK FOOTER //
// ./src/app/components/shared/ztsi-switch/ztsi-switch.component.ts